module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Barcode-6f39b328ae5cfd9d8be152a92d8eb102.svg";